import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getInstitutionsData } from '../../common/api/real-estate-client';

import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import InstitutionsList from './components/InstitutionsList';
import AppBanner from '../../common/components/AppBanner';

// Styles
import './../../common/scss/init.scss';

class InstitutionsListContainer extends Component {
  static NAME = 'InstitutionsListContainer';

  static contextTypes = {
    data: PropTypes.object
  };

  static requestData(req, domain = '') {
    return getInstitutionsData(domain);
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      institutions: context.data[InstitutionsListContainer.NAME] || {}
    };
  }

  render() {
    return (
      <div>
        <InstitutionsList institutions={this.state.institutions} />
        <SessionExpiredModal />
        <Cookies />
        <AppBanner />
      </div>
    );
  }
}

export default InstitutionsListContainer;
